import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Input, Button, Textarea, VStack, Box, Heading, Text, useToast, Spinner } from '@chakra-ui/react';
import axios from 'axios';

const ClubDocumentUpload = () => {
  const { clubId } = useParams();
  const [files, setFiles] = useState([]);
  const [urls, setUrls] = useState(['']);
  const [notes, setNotes] = useState('');
  const [clubName, setClubName] = useState('');
  const [loading, setLoading] = useState(true);
  const toast = useToast();

  useEffect(() => {
    const fetchClub = async () => {
      try {
        const res = await axios.get(`/api/clubs/${clubId}`);
        setClubName(res.data?.name || '');
      } catch (err) {
        setClubName('');
      } finally {
        setLoading(false);
      }
    };
    if (clubId) fetchClub();
  }, [clubId]);

  const handleFileChange = (e) => setFiles(e.target.files);
  const handleUrlChange = (i, value) => {
    const newUrls = [...urls];
    newUrls[i] = value;
    setUrls(newUrls);
  };
  const addUrlField = () => setUrls([...urls, '']);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!clubId) {
      toast({ title: 'Club ID missing in URL', status: 'error' });
      return;
    }
    const formData = new FormData();
    for (let file of files) formData.append('files', file);
    urls.forEach(url => url && formData.append('urls', url));
    formData.append('notes', notes);
    try {
      await axios.post(`/api/documents/club/documents/upload/${clubId}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      toast({ title: 'Documents uploaded successfully!', status: 'success' });
      setFiles([]);
      setUrls(['']);
      setNotes('');
    } catch (err) {
      toast({ title: 'Upload failed', description: err.message, status: 'error' });
    }
  };

  return (
    <Box maxW="lg" mx="auto" mt={8} p={6} boxShadow="md" borderRadius="md">
      {loading ? <Spinner /> : (
        <>
          <Heading size="md" mb={2}>Upload Documents for {clubName || 'Club'}</Heading>
          <Text fontSize="sm" color="gray.400" mb={4}>user ID: {clubId}</Text>
        </>
      )}
      <form onSubmit={handleSubmit}>
        <VStack spacing={4} align="stretch">
          <Input type="file" multiple accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" onChange={handleFileChange} />
          {urls.map((url, i) => (
            <Input key={i} value={url} onChange={e => handleUrlChange(i, e.target.value)} placeholder="Document URL" />
          ))}
          <Button onClick={addUrlField} type="button">Add another URL</Button>
          <Textarea value={notes} onChange={e => setNotes(e.target.value)} placeholder="Notes" />
          <Button type="submit" colorScheme="teal">Upload</Button>
        </VStack>
      </form>
    </Box>
  );
};

export default ClubDocumentUpload; 